export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" stroke="#FF5A1F" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
      <circle cx="14" cy="15" r="9" />
      <path d="M14 15 L14 10" />
      <path d="M11 3 L17 3" />
      <path d="M2 26 L26 26" stroke="#F4F5F2" />
    </svg>
  );
}
